import {
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Input,
  List,
  message,
  Row,
  Select,
  Space,
} from "antd";
import React, { useEffect, useState } from "react";
import Post from "../services/Post";
import Get from "../services/Get";
import { ArrowLeftOutlined } from "@ant-design/icons";

const ApplyCreditCard = () => {
  const [form] = Form.useForm();
  const [operators, setOperators] = useState([]);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [operatorLoading, setOperatorLoading] = useState(true);
  const [selectedOperator, setSelectedOperator] = useState(null);

  const getOperator = () => {
    setOperatorLoading(true);
    Post.CreditCardNetwork()
      .then((res) => {
        console.log("Operators:", res);
        setOperators(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => message.error(err))
      .finally(() => setOperatorLoading(false));
  };

  const handleSubmit = (values) => {
    console.log(values);

    const formData = {
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      mobile: values.mobile,
      pannumber: values.pannumber,
      product_id: selectedOperator?.operator_id, // Use the selected operator
    };

    console.log("Data to send:", formData);

    setLoading(true);
    Post.CreditCardLead(formData)
      .then((res) => {
        if (res.error) {
          message.error(res.error.msg);
          return;
        }
        console.log("Response:", res);
        if (!res.data.link || res.data.link == "") {
            message.error("Failed to retreive payment link");
            setLoading(false);
        }
        const paymentWindow = window.open(
          res.data.link,
          "_blank",
          "width=1500,height=800"
        );

        if (!paymentWindow) {
          message.error("Popup blocked! Please allow popups and try again.");
          setLoading(false);
        }
        message.success("Successfully submitted request!!");
        form.resetFields();
        setSelectedOperator(null); // Reset selection after submission
      })
      .catch((error) => {
        console.error("Error:", error);
        message.error("Something went wrong");
      })
      .finally(() => {
        getLeads();
        setLoading(false);
      });
  };

  const getLeads = () => {
    setLoading(true);
    Get.getCreditCardLeads()
      .then((res) => {
        console.log("Leads:", res);
        setLeads(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => message.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getOperator();
    getLeads();
  }, []);

  return (
    <div>
      <Row className="credit_card_box"
        justify="space-between"
        style={{ margin: 10 }}
      >
        <Col xs={22} sm={16} md={12} lg={9}>
          <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
            {!selectedOperator ? (
              <List
                grid={{ gutter: 16, column: 1 }}
                dataSource={operators}
                loading={operatorLoading}
                renderItem={(card) => (
                  <List.Item>
                    <Card
                      onClick={() => setSelectedOperator(card)}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <img
                          src={card.icon}
                          alt={card.company_name}
                          style={{
                            width: "50px",
                            height: "50px",
                            marginRight: "10px",
                          }}
                        />
                        <h3>{card.operator}</h3>
                      </div>
                      <p>{card.features}</p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <Button type="primary">
                          Earn up to{" "}
                          {card.amount && card.amount !== "null"
                            ? `₹${card.amount}`
                            : "NA"}
                        </Button>
                      </div>
                    </Card>
                  </List.Item>
                )}
              />
            ) : (
              <Card>
                {/* <Button  style={{ marginBottom: 10 }}> */}
                <ArrowLeftOutlined onClick={() => setSelectedOperator(null)} />
                {/* </Button> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={selectedOperator.icon}
                    alt={selectedOperator.company_name}
                    style={{
                      width: "50px",
                      height: "50px",
                      marginRight: "10px",
                    }}
                  />
                  <h3>{selectedOperator.operator}</h3>
                </div>
                <p>{selectedOperator.features}</p>
                <Form
                  form={form}
                  name="user-details-form"
                  onFinish={handleSubmit}
                  layout="vertical"
                >
                  <Form.Item
                    label="First Name"
                    name="firstname"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your first name!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your first name" />
                  </Form.Item>

                  <Form.Item
                    label="Last Name"
                    name="lastname"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your last name!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your last name" />
                  </Form.Item>

                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                      {
                        required: true,
                        message: "Please enter your email address!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your email address" />
                  </Form.Item>

                  <Form.Item
                    label="Mobile Number"
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your mobile number!",
                      },
                    ]}
                  >
                    <Input placeholder="(+91) - Mobile Number" maxLength={10} />
                  </Form.Item>

                  <Form.Item
                    label="PAN Number"
                    name="pannumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your PAN number!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your PAN number" />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="form-btn"
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </div>
        </Col>

        <Col xs={22} sm={16} md={12} lg={14}>
          <List
            itemLayout="vertical"
            size="large"
            loading={loading}
            pagination={{ pageSize: 4 }}
            dataSource={leads}
            renderItem={(item) => (
              <Card
                className="mb-4 p-4 shadow-md rounded-lg"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <List.Item
                  key={item.id}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: 1, minWidth: "250px" }}>
                    <List.Item.Meta
                      title={"Name: " + item.firstname + " " + item.lastname}
                      description={
                        <>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "14px",
                              color: "#666",
                            }}
                          >
                            PAN number: {item.pannumber}
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "14px",
                              color: "#666",
                            }}
                          >
                            Reference Id: {item.refferd_id}
                          </p>
                        </>
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      minWidth: "150px",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor:
                          item.status === "Pending"
                            ? "#f7b825"
                            : item.status === "Success"
                            ? "green"
                            : "red",
                        color: "white",
                      }}
                      disabled
                    >
                      Status: {item.status == "Reject" ? 'Rejected' : item.status}
                    </Button>
                  </div>
                </List.Item>
              </Card>
            )}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ApplyCreditCard;
